import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone } from 'lucide-react';
import { bodyRepairServices, bodyRepairSteps } from '../data/bodyRepair';
const BODY_REPAIR_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/b6e05927-5358-41d4-a29e-d92ab6aff368.jpg';
export function BodyRepairSection() {
  const scrollToBooking = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <section id="body-repair" className="w-full bg-zinc-950 text-white py-24 px-6 md:px-12 lg:px-20 border-t border-white/5" data-id="element-69" data-mp="1w3jkp8lhl6wf">
      <div className="max-w-7xl mx-auto" data-id="element-70" data-mp="1n9ofk0kd7ggs">
        {/* Header */}
        <div className="mb-16 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end" data-id="element-71" data-mp="1n9wsttkegnsi">
          <div className="lg:col-span-7" data-id="element-72" data-mp="1ibv7t33eyeee">
            <div className="flex items-center gap-3 mb-4" data-id="element-73" data-mp="1i8r0hwunj2ji">
              <div className="w-2 h-2 bg-[#6B7A4A] rounded-full pulse-dot" data-id="element-74" data-mp="1daz70yecz8d7" />
              <span className="font-['JetBrains_Mono'] text-xs text-[#6B7A4A] tracking-widest uppercase" data-id="element-75" data-mp="18c4h7chz4jjl">
                Новий напрямок
              </span>
              <span className="text-zinc-700 mx-1" data-id="element-76" data-mp="1cmuct8o00y06">/</span>
              <span className="font-['JetBrains_Mono'] text-xs text-zinc-500 tracking-widest uppercase" data-id="element-77" data-mp="1hg71fisoh4sx">
                UNIT 02
              </span>
            </div>
            <h2 className="font-['Oswald'] text-5xl md:text-6xl font-bold uppercase tracking-widest leading-[0.95]" data-id="element-78" data-mp="17p2oeomkbu0q">
              Кузовний ремонт
              <br data-id="element-79" data-mp="1vfy971slpoyh" />
              <span className="text-[#6B7A4A]" data-id="element-80" data-mp="1vdc55c4x5rl0">після ДТП</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-zinc-400 text-base md:text-lg leading-relaxed font-['Inter']" data-id="element-81" data-mp="20bx5dbk68b9g">
            Відновлюємо автомобіль після аварії так, щоб не залишилось слідів:
            рихтування, фарбування та заміна деталей з тією ж прозорістю, що й
            у слюсарних роботах.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12" data-id="element-82" data-mp="f0oqe8vh4xp6">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-5 relative" data-id="element-83" data-mp="2hnc2g2bwc57w">
            <div className="relative h-full min-h-[320px] border border-white/10 overflow-hidden" data-id="element-84" data-mp="22ypfbeg12964">
              <img src={BODY_REPAIR_IMAGE} alt="Кузовний цех Win Code Garage зі стапелем і автомобілями на ремонті" className="absolute inset-0 w-full h-full object-cover object-[center_55%]" data-id="element-85" data-mp="1xzmksnxoblce" />
              <div className="absolute inset-0 bg-zinc-950/30" data-id="element-86" data-mp="1ozptsfntaae6" />
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-[#6B7A4A]" data-id="element-87" data-mp="1k0d3fkxqel6u" />
              <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-[#6B7A4A]" data-id="element-88" data-mp="3jdh83sh35ify" />
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-[#6B7A4A]" data-id="element-89" data-mp="3edl43t8e1r0e" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-[#6B7A4A]" data-id="element-90" data-mp="3ly5ghk2imtfi" />
              <div className="absolute bottom-5 left-5 bg-zinc-950/85 border border-white/10 px-4 py-2.5" data-id="element-91" data-mp="3qvf4qwe64z1r">
                <span className="font-['JetBrains_Mono'] text-[10px] text-zinc-300 tracking-widest uppercase" data-id="element-92" data-mp="3vohzv8ylggk2">
                  Вартість — після огляду авто
                </span>
              </div>
            </div>
          </motion.div>

          {/* Services list */}
          <div className="lg:col-span-7" data-id="element-93" data-mp="37x2tn53p5f3j">
            <ul className="border-t border-white/10" data-id="element-94" data-mp="37xupmh17heuc">
              {bodyRepairServices.map((service, index) => <motion.li key={service.title} initial={{
              opacity: 0,
              y: 12
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.05,
              ease: [0.23, 1, 0.32, 1]
            }} className="grid grid-cols-1 sm:grid-cols-12 gap-2 sm:gap-6 py-5 border-b border-white/10" data-id="element-95" data-mp="3cys34gb9tkpi" data-mpi={index}>
                  <h3 className="sm:col-span-5 font-['Oswald'] text-lg md:text-xl font-semibold uppercase tracking-wide text-white" data-id="element-96" data-mp="14p2g2qicp5ag">
                    {service.title}
                  </h3>
                  <p className="sm:col-span-7 text-sm md:text-base text-zinc-400 leading-relaxed font-['Inter']" data-id="element-97" data-mp="zsc1k7m72hr5">
                    {service.description}
                  </p>
                </motion.li>)}
            </ul>

            <div className="mt-8 flex flex-col sm:flex-row gap-3" data-id="element-98" data-mp="1nfto9oqlqpn9">
              <button type="button" onClick={scrollToBooking} className="group flex items-center justify-between gap-6 bg-[#6B7A4A] hover:bg-[#7d8c5a] text-white font-['Oswald'] uppercase tracking-widest py-4 px-6 transition-colors duration-200" data-id="element-99" data-mp="1iggz2xc9d6hi">
                <span data-id="element-100" data-mp="2c0q0tyc0v0qd">Записатися на огляд</span>
                <ArrowRight className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-1" data-id="element-101" data-mp="2c0yazigrfrxv" />
              </button>
              <a href="tel:+380774500450" className="flex items-center justify-center gap-3 border border-white/15 hover:border-[#6B7A4A] text-white font-['Oswald'] uppercase tracking-widest py-4 px-6 transition-colors duration-200" data-id="element-102" data-mp="2fzp99swypfmk">
                <Phone className="w-4 h-4 text-[#6B7A4A]" data-id="element-103" data-mp="1sactubb1kbbt" />
                <span className="whitespace-nowrap" data-id="element-104" data-mp="1x47lq20svwlz">+380 77 450 0450</span>
              </a>
            </div>
          </div>
        </div>

        {/* Process */}
        <div className="mt-20" data-id="element-105" data-mp="1oavnzgrpdc64">
          <div className="flex items-center justify-between mb-8 pb-4 border-b border-white/10" data-id="element-106" data-mp="1oa2lwt3ovaub">
            <span className="font-['Oswald'] text-2xl font-bold text-white uppercase tracking-widest" data-id="element-107" data-mp="19dbpmspbaf8x">
              Як проходить ремонт
            </span>
            <span className="font-['JetBrains_Mono'] text-xs text-zinc-600 tracking-wider" data-id="element-108" data-mp="1eeitigoc2uab">
              {bodyRepairSteps.length} ЕТАПИ
            </span>
          </div>
          <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-109" data-mp="qfs104c4t9gt">
            {bodyRepairSteps.map((step, index) => <li key={step.title} className="relative" data-id="element-110" data-mp="gj6tnccn3m9t" data-mpi={index}>
                <div className="flex items-center gap-3 mb-4" data-id="element-111" data-mp="gkq8qzmk7ra0">
                  <span className="font-['JetBrains_Mono'] text-sm text-[#6B7A4A] tracking-widest" data-id="element-112" data-mp="1e7gv9q8ik80e">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="flex-1 h-px bg-white/10" data-id="element-113" data-mp="148hl2383o4ba" />
                </div>
                <h3 className="font-['Oswald'] text-xl font-semibold uppercase tracking-wide text-white mb-2" data-id="element-114" data-mp="14akmrkim7lvu">
                  {step.title}
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed font-['Inter']" data-id="element-115" data-mp="3ozrwscilbl50">
                  {step.description}
                </p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}